import * as React from 'react';
import { Controller, IDynamicLoader, Loader, Toolbar, skipWithDefault } from '@tencent/workbench';
import { IGridLineFeature } from './grid-line-interface';
import { TOOLBAR_ITEMS, config } from './config';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class GridLineController {
    public constructor(@Loader(IGridLineFeature) private loader: IDynamicLoader<IGridLineFeature>) {
    }

    private get feature() {
        return this.loader.instance!;
    }

    @Toolbar(config.id, 'content')
    @skipWithDefault(<></>)
    public gridLineContent() {
        return this.feature.getContent();
    }
}
